module.exports = __webpack_public_path__ + "static/media/fondo-perfil-verdel.f71b797c.png";